export default __webpack_public_path__ + "static/media/diploma-bazi-expertos_2024.57517a2f.jpeg";